define('models/WidgetInstanceCollection',['underscore','ObjectCollection','LocalStorage','WidgetInstanceModel','hooks'],function (_,ObjectCollection,LocalStorage,WidgetInstanceModel,hooks) {
    //
    // Collection WidgetInstance
    //
    var WidgetInstanceCollectionPrototype = {
        
        name:'WidgetInstanceCollection',
        route:'apiWidgetInstanceCollection',
        model: function(attr,options){
            var modelClass = WidgetInstanceModel;
            hooks.execHook('factoryWidgetInstanceModel',attr,function(instanceClass){
                if(instanceClass){
                    modelClass = instanceClass;
                }
            });
            return new modelClass(attr,options);
        },
        
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
    };

    var WidgetInstanceCollection = ObjectCollection.extend(WidgetInstanceCollectionPrototype);

    return WidgetInstanceCollection;
});
